import http from '@/utils/http'

export const loadSystemInfo = (nodeID, params = {}) => http.get(`/kuiper/${nodeID}`, { params })

export default {}
